module.exports = require('./helpers/bundle-url').getBundleURL('2av5d') + "hontar.7410e973.jpg";